{
  "page_count": "z {n, plural, one{# strony} other{# stron}}"
}
